import React from 'react';
import experiencesData from "./Experience.json"; // Import your JSON data
import './Experience.css'; // Import the CSS file for styling

const Experience = () => {
  return (
    <div id="experiences" className="experience-container">
      <h2 className='experience-heading'>Experiences</h2>
      <div className="experience-list">
        {experiencesData.map((experience) => (
          <div key={experience.id} className="experience-item">
            <div className="experience-info">
              <h3>{experience.title}</h3>
              <p>{experience.company}</p>
              <p>{experience.duration}</p>
              <ul className="responsibilities">
                {experience.responsibilities.map((responsibility, index) => (
                  <li key={index}>{responsibility}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
